import { render, staticRenderFns } from "./ClientUserListItem.vue?vue&type=template&id=c64c0448&"
import script from "./ClientUserListItem.vue?vue&type=script&lang=js&"
export * from "./ClientUserListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports